export { Breadcrumbs } from '@mantine/core'